import React, { useState } from 'react';
import c from '../../constants/Colors';
import { data } from '../../constants/Constants';

function CardPrecios(props) {
    // console.log("modal carrito",props.data)
    let getClassNameForPrice = (item, data) => {
        if (item.codigo) {
            switch (item.tipo) {
                case data.PrecioOfe:
                    return { color: c.azulClaro, };
                case data.PrecioFin:
                    return { color: c.naranja, fontFamily: 'gotham-bold', };
                case data.PrecioPub:
                    return { color: c.azulClaro };
                default:
                    return { color: c.azulClaro, };
            }
        } else {
            switch (item.tipo) {
                case data.PrecioOfe:
                    return { color: c.azulClaro, };
                case data.PrecioFin:
                    return { color: c.naranja, fontFamily: 'gotham-bold' };
                case data.PrecioPub:
                    return { color: c.grisOscuro, textDecorationLine: 'line-through', };
                default:
                    return { color: c.azulClaro, };
            }
        }
    }
    let toFixed = (x) => {
        if (Math.abs(x) < 1.0) {
            let e = parseInt(x.toString().split('e-')[1]);
            if (e) {
                x *= Math.pow(10, e - 1);
                x = '0.' + (new Array(e)).join('0') + x.toString().substring(2);
            }
        } else {
            let e = parseInt(x.toString().split('+')[1]);
            if (e > 20) {
                e -= 20;
                x /= Math.pow(10, e);
                x += (new Array(e + 1)).join('0');
            }
        }
        return x;
    }
    let toFixedTrunc = (x, n) => {
        x = toFixed(x)

        // From here on the code is the same than the original answer
        const v = (typeof x === 'string' ? x : x.toString()).split('.');
        if (n <= 0) return v[0];
        let f = v[1] || '';
        if (f.length > n) return `${v[0]}.${f.substr(0, n)}`;
        while (f.length < n) f += '0';
        return `${v[0]}.${f}`
    }
    let round = (num, decimalPlaces = 0) => {
        num = Math.round(num + "e" + decimalPlaces);
        return Number(num + "e" + -decimalPlaces);
    }
    let getValueForPrice = (item, precios, escalas, cantidad) => {

        if (cantidad == 0 || escalas == null) {
            return item.precioStr
        } else {
            let scala = escalas ? escalas.filter(p => cantidad >= p.cantdesde && cantidad <= p.canthasta) : null;
            let PVP = precios.filter(x => x.tipo == data.PrecioPub)
            if (scala.length == 0)
                return item.precioStr
            else if (scala && PVP) {
                var dec = (1 - (scala[0].porcdesc / 100)) * PVP[0].precio;
                let precioPar = `PVD S/ ${round(dec, 2).toFixed(2)} UN `;
                // console.log("Value escala==>", scala[0], PVP[0], precioPar);
                return precioPar
            }
        }
    }
    return (
        // <div>
        // <div className={"price"}>
        <div className={props.className}>
            {(props.data) ? props.data.map((item, index) => {
                return (
                    (item.tipo == data.PrecioFin) ?
                        <span key={index} style={getClassNameForPrice(item, data)}>{getValueForPrice(item, props.data, props.escalas, props.cantidad)}</span>
                        :
                        <span key={index} style={getClassNameForPrice(item, data)} >{item.precioStr}</span>
                )
            }) : null}
        </div>
        // </div>
    );
}

export default CardPrecios;  